import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { PERMISSION_SUB_MODULES } from '@/shared/const'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PermissionGuard } from '@/shared/ui/permission-guard'
import { UsersCommentsWidget } from '@/widgets/users-comments-widget'

const searchSchema = z.object({
  'pagination.page': z.number().default(1).optional(),
  'pagination.pageSize': z.number().default(10).optional(),
  'filter.schoolId': z.string().optional(),
  'filter.canteenId': z.string().optional(),
  'filter.grade': z.number().optional(),
  'filter.letter': z.string().optional(),
  'filter.studentName': z.string().optional(),
  'filter.datetimeCommentFrom': z.string().optional(),
  'filter.datetimeCommentTo': z.string().optional(),
  'filter.active': z.boolean().optional(),
})

export const Route = createFileRoute('/_auth/canteen/user-comments')({
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  return (
    <PermissionGuard permission={PERMISSION_SUB_MODULES.USER_COMMENTS}>
      <PageWrapper title={t('Комментарии пользователей')}>
        <UsersCommentsWidget />
        <Outlet />
      </PageWrapper>
    </PermissionGuard>
  )
}
